import { AccordionSummary, type AccordionSummaryProps } from "@mui/material";
import type React from "react";
import { BaseIcon } from "../BaseIcons";

export const BaseAccordionSummary: React.FC<AccordionSummaryProps> = (
  props,
) => {
  return (
    <AccordionSummary
      expandIcon={
        <BaseIcon
          name="chevronDown"
          htmlColor="#52A48B"
          sx={{
            border: "1px solid",
            borderColor: "grey.300",
            borderRadius: "200px",
          }}
        />
      }
      sx={{
        fontWeight: 700,
        borderRadius: "16px",
      }}
      {...props}
    >
      {props.children}
    </AccordionSummary>
  );
};
